const initialState = () => {
    return {
        /**
         * @description
         * Contains properties to format the modal snackbar
         * and data that it shows to the user about an
         * event they unleash.
         */
        typeMessage: '', //success | warning | info | error
        showSnack: false,
        showProgress: false,
        timeout: 0,
        closeOptions: {
            text: "cerrar",
            show: true,
        },
        alignTop: false,
        message: {
            title: "",
            body: ""
        },
        enableConfirm:false,
        messageConfirm:'', //anular |eliminar | etc
        responseConfirm:'',
    }
}

export default initialState
